import { Injectable } from '@angular/core';
import { BaseFormService } from '../../utils/base-form-service';
import { AgStripeSubtotalKeys, ProcessRefundPayload, StripeTransactionKeys } from 'ag-common-lib/public-api';

@Injectable()
export class AttendeeManualRefundPaymentModalService extends BaseFormService<ProcessRefundPayload> {
  constructor() {
    super();
  }

  getFormData = (refundTransaction?: Partial<ProcessRefundPayload>) => {
    this.formData = new Proxy(Object.assign({}, new ProcessRefundPayload(), refundTransaction), {
      set: (target, prop, value, receiver) => {
        const prevValue = target[prop];
        this.formChangesDetector.handleChange(prop, value, prevValue);
        Reflect.set(target, prop, value, receiver);

        switch (prop) {
          case StripeTransactionKeys.details:
            const totalAmount = value.reduce((sum, obj) => sum + Number(obj[AgStripeSubtotalKeys.amount]), 0);

            Object.assign(this.formData, { [StripeTransactionKeys.amount]: totalAmount });
            break;
        }

        return true;
      },
    });
    return this.formData;
  };
}
